import { useState, useEffect, useRef } from "react";
const Sparkles = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/></svg>;
const BarChart3 = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="12" width="4" height="9"/><rect x="10" y="6" width="4" height="15"/><rect x="17" y="3" width="4" height="18"/></svg>;
const Brain = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/></svg>;
const MessageCircle = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const Smartphone = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>;
const ChevronDown = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>;
const Star = ({ fill = "none", size = 12 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke="#C9A84C" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const ArrowRight = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;
const Zap = ({ size = 20 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const Shield = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;

const useScrollAnimation = (threshold = 0.15) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
};

const AnimatedSection = ({ children, delay = 0, className = "" }) => {
  const [ref, visible] = useScrollAnimation();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0px)" : "translateY(40px)",
        transition: `opacity 0.8s ease ${delay}s, transform 0.8s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

const GoldDivider = () => (
  <div style={{ display: "flex", alignItems: "center", gap: "12px", margin: "0 auto", width: "fit-content" }}>
    <div style={{ width: "40px", height: "1px", background: "linear-gradient(to right, transparent, #C9A84C)" }} />
    <div style={{ width: "4px", height: "4px", background: "#C9A84C", borderRadius: "50%", transform: "rotate(45deg)" }} />
    <div style={{ width: "40px", height: "1px", background: "linear-gradient(to left, transparent, #C9A84C)" }} />
  </div>
);

const ParticleField = () => {
  const particles = Array.from({ length: 30 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 2 + 1,
    delay: Math.random() * 4,
    duration: Math.random() * 4 + 3,
  }));
  return (
    <div style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}>
      {particles.map((p) => (
        <div
          key={p.id}
          style={{
            position: "absolute",
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            borderRadius: "50%",
            background: "#C9A84C",
            opacity: 0,
            animation: `twinkle ${p.duration}s ${p.delay}s infinite`,
          }}
        />
      ))}
      <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0; transform: scale(0); }
          50% { opacity: 0.7; transform: scale(1); }
        }
        @keyframes floatOrb {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          33% { transform: translateY(-20px) translateX(10px); }
          66% { transform: translateY(10px) translateX(-10px); }
        }
        @keyframes rotateSlow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes pulseGold {
          0%, 100% { box-shadow: 0 0 20px rgba(201,168,76,0.3); }
          50% { box-shadow: 0 0 60px rgba(201,168,76,0.7), 0 0 100px rgba(201,168,76,0.3); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes lineExpand {
          from { width: 0; }
          to { width: 60px; }
        }
        @keyframes orbFloat1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(30px, -40px) scale(1.1); }
        }
        @keyframes orbFloat2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-20px, 30px) scale(0.9); }
        }
        @keyframes borderGlow {
          0%, 100% { border-color: rgba(201,168,76,0.2); }
          50% { border-color: rgba(201,168,76,0.6); }
        }
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; }
      `}</style>
    </div>
  );
};

export default function LilyLanding() {
  const [scrolled, setScrolled] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [ctaUrl] = useState("https://lilysaju.netlify.app/");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const features = [
    {
      icon: <BarChart3 size={22} />,
      title: "데이터 기반 명리학",
      subtitle: "DATA-DRIVEN BAZI",
      desc: "수십만 건의 명리 데이터를 정량 분석해 당신의 사주를 통계적으로 해석합니다. 직관이 아닌 근거 있는 통찰을.",
    },
    {
      icon: <Brain size={22} />,
      title: "AI 전략 리포트",
      subtitle: "AI STRATEGY REPORT",
      desc: "AI와 전통 명리학을 결합한 릴리만의 알고리즘이 재운·직업운·관계운을 종합한 하이브리드 맞춤 전략을 제공합니다.",
    },
    {
      icon: <Shield size={22} />,
      title: "1:1 퍼스널 케어",
      subtitle: "PERSONAL CARE",
      desc: "전담 명리 전문가가 분석 리포트를 함께 해석하고 당신의 결정적 순간마다 전략적 조언을 드립니다.",
    },
  ];

  const steps = [
    {
      num: "01",
      icon: <MessageCircle size={20} />,
      title: "카카오톡으로 시작",
      desc: "카카오톡 채널에서 생년월일시를 입력하는 것만으로 릴리와의 첫 만남이 시작됩니다.",
    },
    {
      num: "02",
      icon: <Zap size={20} />,
      title: "AI 사주 분석",
      desc: "릴리AI가 당신의 사주 원국을 즉시 분석하고 핵심 운의 흐름을 파악하여 실시간으로 도움을 제공합니다.",
    },
    {
      num: "03",
      icon: <Smartphone size={20} />,
      title: "전용 앱 정밀 리포트",
      desc: "전용 앱에서 연간·월간 운세 전략, 직업·재운 분석 등 더욱 자세한 풀 리포트를 받아보세요.",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100dvh",
        background: "#0D0D12",
        color: "#E8E0D5",
        fontFamily: "'Noto Serif KR', 'Cormorant Garamond', Georgia, serif",
        overflowX: "hidden",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      {/* NAV */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          padding: "16px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: scrolled ? "rgba(13,13,18,0.92)" : "transparent",
          backdropFilter: scrolled ? "blur(20px)" : "none",
          borderBottom: scrolled ? "1px solid rgba(201,168,76,0.15)" : "none",
          transition: "all 0.4s ease",
          paddingTop: "calc(16px + env(safe-area-inset-top))",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              border: "1.5px solid #C9A84C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "pulseGold 3s infinite",
            }}
          >
            <Star size={12} fill="#C9A84C" color="#C9A84C" />
          </div>
          <span style={{ fontSize: "18px", letterSpacing: "4px", color: "#C9A84C", fontWeight: 600 }}>LILY</span>
        </div>
        <button
          onClick={() => window.open(ctaUrl, "_blank")}
          style={{
            background: "transparent",
            border: "1px solid rgba(201,168,76,0.5)",
            color: "#C9A84C",
            padding: "8px 18px",
            borderRadius: "2px",
            fontSize: "11px",
            letterSpacing: "2px",
            cursor: "pointer",
          }}
        >
          시작하기
        </button>
      </nav>

      {/* HERO */}
      <section
        style={{
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          textAlign: "center",
          padding: "120px 24px 80px",
        }}
      >
        <ParticleField />

        <div
          style={{
            position: "absolute",
            width: "350px",
            height: "350px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(98,65,145,0.25) 0%, transparent 70%)",
            top: "15%",
            left: "-10%",
            animation: "orbFloat1 8s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "250px",
            height: "250px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(201,168,76,0.1) 0%, transparent 70%)",
            bottom: "20%",
            right: "-5%",
            animation: "orbFloat2 10s ease-in-out infinite",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            border: "1px solid rgba(201,168,76,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "40px",
            position: "relative",
            animation: "pulseGold 4s infinite",
          }}
        >
          <div
            style={{
              width: "90px",
              height: "90px",
              borderRadius: "50%",
              border: "1px solid rgba(201,168,76,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              animation: "rotateSlow 20s linear infinite",
            }}
          >
            <div style={{ transform: "rotate(-1turn)" }}>
              <Sparkles size={28} color="#C9A84C" />
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              background: "#C9A84C",
              top: "4px",
              left: "50%",
              marginLeft: "-3px",
              boxShadow: "0 0 10px #C9A84C",
              animation: "rotateSlow 5s linear infinite",
              transformOrigin: "3px 57px",
            }}
          />
        </div>

        <div style={{ animation: "fadeInUp 1s ease 0.2s both" }}>
          <p style={{ fontSize: "10px", letterSpacing: "5px", color: "#C9A84C", marginBottom: "20px", opacity: 0.8 }}>
            AI 사주 메이트 · 카카오톡으로 바로 사용
          </p>
        </div>

        <div style={{ animation: "fadeInUp 1s ease 0.4s both" }}>
          <h1
            style={{
              fontSize: "clamp(28px, 7vw, 46px)",
              fontWeight: 700,
              lineHeight: 1.3,
              letterSpacing: "-0.5px",
              marginBottom: "8px",
              background: "linear-gradient(135deg, #E8E0D5 0%, #C9A84C 50%, #E8E0D5 100%)",
              backgroundSize: "200% auto",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              animation: "shimmer 4s linear infinite",
            }}
          >
            불안할 때, 카톡으로
          </h1>
          <h1
            style={{
              fontSize: "clamp(28px, 7vw, 46px)",
              fontWeight: 700,
              lineHeight: 1.3,
              letterSpacing: "-0.5px",
              marginBottom: "20px",
              background: "linear-gradient(135deg, #C9A84C 0%, #E8E0D5 50%, #C9A84C 100%)",
              backgroundSize: "200% auto",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              animation: "shimmer 4s linear infinite 0.5s",
            }}
          >
            바로 물어보세요
          </h1>
        </div>

        <div style={{ animation: "fadeInUp 1s ease 0.6s both" }}>
          <p
            style={{
              fontSize: "14px",
              lineHeight: 1.85,
              color: "rgba(232,224,213,0.65)",
              maxWidth: "300px",
              margin: "0 auto 32px",
              letterSpacing: "0.3px",
            }}
          >
            소개팅 잘 될까? 이직해도 될까?<br />
            릴리가 당신의 사주로 <strong style={{ color: "rgba(201,168,76,0.9)" }}>지금 바로</strong> 답해드려요
          </p>
        </div>

        <div style={{ animation: "fadeInUp 1s ease 0.8s both", display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
          <button
            onClick={() => window.open(ctaUrl, "_blank")}
            style={{
              background: "linear-gradient(135deg, #C9A84C, #A07830)",
              border: "none",
              color: "#0D0D12",
              padding: "18px 40px",
              fontSize: "15px",
              fontWeight: 700,
              letterSpacing: "0.5px",
              borderRadius: "4px",
              cursor: "pointer",
              boxShadow: "0 8px 40px rgba(201,168,76,0.4)",
              fontFamily: "inherit",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            지금 무료로 물어보기 →
          </button>
          <p style={{ fontSize: "11px", color: "rgba(232,224,213,0.3)", letterSpacing: "1px", margin: 0 }}>
            카카오톡 연결 · 무료 · 1분이면 시작
          </p>
        </div>

        <div
          style={{
            position: "absolute",
            bottom: "32px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
            opacity: 0.4,
            animation: "fadeIn 2s ease 2s both",
          }}
        >
          <ChevronDown size={18} color="#C9A84C" />
        </div>
      </section>

      {/* CHAT DEMO */}
      <section style={{ padding: "60px 24px", background: "#0F0F15" }}>
        <AnimatedSection>
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <p style={{ fontSize: "10px", letterSpacing: "4px", color: "#C9A84C", marginBottom: "12px" }}>REAL CONVERSATION</p>
            <h2 style={{ fontSize: "clamp(20px, 5vw, 28px)", fontWeight: 700, lineHeight: 1.4 }}>
              이런 고민, 바로 물어보세요
            </h2>
          </div>
        </AnimatedSection>

        <div style={{ maxWidth: "400px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "32px" }}>

          {/* 대화 예시 1 */}
          <AnimatedSection delay={0.1}>
            <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(201,168,76,0.1)", borderRadius: "12px", padding: "20px 16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              <p style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(201,168,76,0.5)", margin: 0 }}>연애 · 소개팅</p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: "80%", background: "rgba(98,65,145,0.3)", border: "1px solid rgba(98,65,145,0.4)", borderRadius: "16px 16px 4px 16px", padding: "10px 14px" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.65, color: "rgba(232,224,213,0.85)", margin: 0 }}>오늘 소개팅인데 잘 될 것 같아?</p>
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
                <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "linear-gradient(135deg, #4A2E7A, #C9A84C)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "10px", fontWeight: 700, color: "#fff" }}>L</div>
                <div style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.05))", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "4px 16px 16px 16px", padding: "10px 14px", maxWidth: "82%" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.7, color: "rgba(232,224,213,0.9)", margin: 0 }}>오늘 목(木) 일간에 화(火) 기운이 들어오는 날이에요 🔥 감정 표현이 자연스럽게 되고 상대방도 당신 매력에 끌릴 확률 높아요. <span style={{ color: "#C9A84C", fontWeight: 700 }}>붉은 계열 포인트 아이템</span> 하나만 챙기세요!</p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* 대화 예시 2 */}
          <AnimatedSection delay={0.2}>
            <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(201,168,76,0.1)", borderRadius: "12px", padding: "20px 16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              <p style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(201,168,76,0.5)", margin: 0 }}>직장 · 커리어</p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: "80%", background: "rgba(98,65,145,0.3)", border: "1px solid rgba(98,65,145,0.4)", borderRadius: "16px 16px 4px 16px", padding: "10px 14px" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.65, color: "rgba(232,224,213,0.85)", margin: 0 }}>이직 제안 받았는데 지금 가도 괜찮을까?</p>
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
                <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "linear-gradient(135deg, #4A2E7A, #C9A84C)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "10px", fontWeight: 700, color: "#fff" }}>L</div>
                <div style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.05))", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "4px 16px 16px 16px", padding: "10px 14px", maxWidth: "82%" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.7, color: "rgba(232,224,213,0.9)", margin: 0 }}>올해 대운이 <span style={{ color: "#C9A84C", fontWeight: 700 }}>변화와 확장</span>을 지지하고 있어요. 지금 움직이는 게 맞아요 ✨ 단, 계약서 사인은 <span style={{ color: "#C9A84C", fontWeight: 700 }}>다음 달 초</span>가 더 좋아요. 지금은 협상 단계로만 진행하세요.</p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* 대화 예시 3 */}
          <AnimatedSection delay={0.3}>
            <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(201,168,76,0.1)", borderRadius: "12px", padding: "20px 16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              <p style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(201,168,76,0.5)", margin: 0 }}>일상 · 오늘의 운세</p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: "80%", background: "rgba(98,65,145,0.3)", border: "1px solid rgba(98,65,145,0.4)", borderRadius: "16px 16px 4px 16px", padding: "10px 14px" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.65, color: "rgba(232,224,213,0.85)", margin: 0 }}>오늘 중요한 발표 있는데 어떻게 하면 좋아?</p>
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
                <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "linear-gradient(135deg, #4A2E7A, #C9A84C)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "10px", fontWeight: 700, color: "#fff" }}>L</div>
                <div style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.05))", border: "1px solid rgba(201,168,76,0.2)", borderRadius: "4px 16px 16px 16px", padding: "10px 14px", maxWidth: "82%" }}>
                  <p style={{ fontSize: "13px", lineHeight: 1.7, color: "rgba(232,224,213,0.9)", margin: 0 }}>오늘 금(金)의 기운이 강해서 논리와 설득력이 빛나는 날이에요 💪 발표 자료 첫 장에 <span style={{ color: "#C9A84C", fontWeight: 700 }}>숫자나 데이터</span> 넣으면 신뢰감 확 올라가요. 서쪽 자리 앉는 것도 잊지 마세요!</p>
                </div>
              </div>
            </div>
          </AnimatedSection>

        </div>

        {/* 중간 CTA */}
        <AnimatedSection delay={0.3}>
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => window.open(ctaUrl, "_blank")}
              style={{
                background: "transparent",
                border: "1px solid rgba(201,168,76,0.5)",
                color: "#C9A84C",
                padding: "14px 32px",
                fontSize: "13px",
                fontWeight: 600,
                borderRadius: "4px",
                cursor: "pointer",
                fontFamily: "inherit",
                letterSpacing: "0.5px",
              }}
            >
              나도 릴리에게 물어보기 →
            </button>
          </div>
        </AnimatedSection>
      </section>

      {/* FEATURES */}
      <section style={{ padding: "80px 24px", background: "#0D0D12" }}>
        <AnimatedSection style={{ textAlign: "center", marginBottom: "60px" }}>
          <p style={{ fontSize: "10px", letterSpacing: "4px", color: "#C9A84C", marginBottom: "16px" }}>WHY LILY</p>
          <h2 style={{ fontSize: "clamp(24px, 6vw, 36px)", fontWeight: 700, marginBottom: "16px", letterSpacing: "-0.3px" }}>
            명리학이 전략이 되는 순간
          </h2>
          <GoldDivider />
        </AnimatedSection>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px", maxWidth: "480px", margin: "0 auto" }}>
          {features.map((f, i) => (
            <AnimatedSection key={i} delay={i * 0.15}>
              <div
                style={{
                  background: "linear-gradient(135deg, rgba(98,65,145,0.08) 0%, rgba(201,168,76,0.05) 100%)",
                  border: "1px solid rgba(201,168,76,0.12)",
                  borderRadius: "4px",
                  padding: "28px 24px",
                  animation: "borderGlow 4s ease-in-out infinite",
                  animationDelay: `${i * 1.5}s`,
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "18px" }}>
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                      background: "rgba(201,168,76,0.1)",
                      border: "1px solid rgba(201,168,76,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#C9A84C",
                      flexShrink: 0,
                    }}
                  >
                    {f.icon}
                  </div>
                  <div>
                    <p style={{ fontSize: "9px", letterSpacing: "3px", color: "rgba(201,168,76,0.6)", marginBottom: "6px" }}>
                      {f.subtitle}
                    </p>
                    <h3 style={{ fontSize: "17px", fontWeight: 700, marginBottom: "10px", letterSpacing: "0.3px" }}>
                      {f.title}
                    </h3>
                    <p style={{ fontSize: "13px", lineHeight: 1.75, color: "rgba(232,224,213,0.6)", letterSpacing: "0.2px" }}>
                      {f.desc}
                    </p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section style={{ padding: "80px 24px", position: "relative" }}>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "radial-gradient(circle at 50% 0%, rgba(98,65,145,0.12) 0%, transparent 60%)",
            pointerEvents: "none",
          }}
        />
        <AnimatedSection style={{ textAlign: "center", marginBottom: "60px" }}>
          <p style={{ fontSize: "10px", letterSpacing: "4px", color: "#C9A84C", marginBottom: "16px" }}>HOW IT WORKS</p>
          <h2 style={{ fontSize: "clamp(24px, 6vw, 36px)", fontWeight: 700, marginBottom: "16px" }}>
            3단계로 시작하는 운의 전략
          </h2>
          <GoldDivider />
        </AnimatedSection>

        <div style={{ display: "flex", flexDirection: "column", gap: "0px", maxWidth: "420px", margin: "0 auto" }}>
          {steps.map((s, i) => (
            <AnimatedSection key={i} delay={i * 0.2}>
              <div style={{ display: "flex", gap: "20px", padding: "0 0 40px 0", position: "relative" }}>
                {i < steps.length - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      left: "21px",
                      top: "52px",
                      width: "1px",
                      bottom: 0,
                      background: "linear-gradient(to bottom, rgba(201,168,76,0.4), transparent)",
                    }}
                  />
                )}
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    background: "rgba(13,13,18,0.9)",
                    border: "1px solid rgba(201,168,76,0.4)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#C9A84C",
                    flexShrink: 0,
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {s.icon}
                </div>
                <div style={{ paddingTop: "8px", flex: 1 }}>
                  <p style={{ fontSize: "10px", letterSpacing: "3px", color: "rgba(201,168,76,0.5)", marginBottom: "6px" }}>
                    STEP {s.num}
                  </p>
                  <h3 style={{ fontSize: "16px", fontWeight: 700, marginBottom: "8px" }}>{s.title}</h3>
                  <p style={{ fontSize: "13px", lineHeight: 1.75, color: "rgba(232,224,213,0.6)", marginBottom: s.num === "02" ? "20px" : "0" }}>{s.desc}</p>

                  {s.num === "02" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                      <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div
                          style={{
                            maxWidth: "82%",
                            background: "rgba(98,65,145,0.25)",
                            border: "1px solid rgba(98,65,145,0.4)",
                            borderRadius: "16px 16px 4px 16px",
                            padding: "11px 14px",
                          }}
                        >
                          <p style={{ fontSize: "12px", lineHeight: 1.65, color: "rgba(232,224,213,0.85)", margin: 0 }}>
                            이따 오후 2시에 기획안 최종 보고가 있어. 떨리는데 잘 할 수 있을까?ㅜㅜ
                          </p>
                          <p style={{ fontSize: "10px", color: "rgba(232,224,213,0.3)", margin: "5px 0 0", textAlign: "right" }}>오후 12:31</p>
                        </div>
                      </div>

                      <div style={{ display: "flex", justifyContent: "flex-start", gap: "8px", alignItems: "flex-start" }}>
                        <div
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #4A2E7A, #C9A84C)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            fontSize: "11px",
                            fontWeight: 700,
                            color: "#fff",
                            letterSpacing: "0.5px",
                          }}
                        >
                          L
                        </div>
                        <div style={{ maxWidth: "82%" }}>
                          <p style={{ fontSize: "10px", color: "rgba(201,168,76,0.6)", margin: "0 0 5px 2px", letterSpacing: "1px" }}>LILY</p>
                          <div
                            style={{
                              background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.06))",
                              border: "1px solid rgba(201,168,76,0.25)",
                              borderRadius: "4px 16px 16px 16px",
                              padding: "12px 14px",
                            }}
                          >
                            <p style={{ fontSize: "12px", lineHeight: 1.7, color: "rgba(232,224,213,0.9)", margin: 0 }}>
                              오늘 오후 2시 회의, 긴장하지 마세요! ✨<br />
                              사주에 <span style={{ color: "#C9A84C", fontWeight: 700 }}>'금(金)'의 기운</span>이 강한 날이라 논리적 설득력이 폭발합니다.<br />
                              서쪽을 바라보고 앉아야 기운이 살아나요 :)
                            </p>
                            <p style={{ fontSize: "10px", color: "rgba(232,224,213,0.3)", margin: "5px 0 0" }}>오후 12:32</p>
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "4px" }}>
                        <div
                          style={{
                            maxWidth: "82%",
                            background: "rgba(98,65,145,0.25)",
                            border: "1px solid rgba(98,65,145,0.4)",
                            borderRadius: "16px 16px 4px 16px",
                            padding: "11px 14px",
                          }}
                        >
                          <p style={{ fontSize: "12px", lineHeight: 1.65, color: "rgba(232,224,213,0.85)", margin: 0 }}>
                            저녁에 진짜 중요한 비즈니스 미팅이 있어. 어떤 스타일링을 해야 좋은지 추천좀!
                          </p>
                          <p style={{ fontSize: "10px", color: "rgba(232,224,213,0.3)", margin: "5px 0 0", textAlign: "right" }}>오후 12:34</p>
                        </div>
                      </div>

                      <div style={{ display: "flex", justifyContent: "flex-start", gap: "8px", alignItems: "flex-start" }}>
                        <div
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "linear-gradient(135deg, #4A2E7A, #C9A84C)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            fontSize: "11px",
                            fontWeight: 700,
                            color: "#fff",
                            letterSpacing: "0.5px",
                          }}
                        >
                          L
                        </div>
                        <div style={{ maxWidth: "82%" }}>
                          <p style={{ fontSize: "10px", color: "rgba(201,168,76,0.6)", margin: "0 0 5px 2px", letterSpacing: "1px" }}>LILY</p>
                          <div
                            style={{
                              background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.06))",
                              border: "1px solid rgba(201,168,76,0.25)",
                              borderRadius: "4px 16px 16px 16px",
                              padding: "12px 14px",
                            }}
                          >
                            <p style={{ fontSize: "12px", lineHeight: 1.7, color: "rgba(232,224,213,0.9)", margin: 0 }}>
                              오늘 당신을 빛내줄 행운의 아이템은 ✨<br />
                              <span style={{ color: "#7EB8E8", fontWeight: 700 }}>#네이비_재킷</span>과 <span style={{ color: "#C0C8D8", fontWeight: 700 }}>#실버_반지</span>예요.<br /><br />
                              사람들과 만날 때 이 컬러를 곁들이면 존재감이 훨씬 부드러워 보여 대화 상대의 호감을 사게 될 거예요 :)
                            </p>
                            <p style={{ fontSize: "10px", color: "rgba(232,224,213,0.3)", margin: "5px 0 0" }}>오후 12:35</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section style={{ padding: "60px 24px", background: "#0F0F15" }}>
        <AnimatedSection>
          <div
            style={{
              maxWidth: "420px",
              margin: "0 auto",
              textAlign: "center",
              padding: "40px 28px",
              border: "1px solid rgba(201,168,76,0.15)",
              borderRadius: "4px",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-12px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "#0F0F15",
                padding: "0 16px",
              }}
            >
              <GoldDivider />
            </div>
            <p
              style={{
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: 1.6,
                letterSpacing: "0.5px",
                marginBottom: "20px",
                background: "linear-gradient(135deg, #E8E0D5, #C9A84C)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              "운은 아는 것만으로<br />충분하지 않습니다.<br />실시간으로 여러분의 삶에<br />직접 도움될<br />'진짜' 전략이 필요합니다."
            </p>
            <p style={{ fontSize: "11px", letterSpacing: "2px", color: "rgba(201,168,76,0.6)" }}>— LILY AI</p>
          </div>
        </AnimatedSection>
      </section>

      {/* CTA */}
      <section
        style={{
          padding: "80px 24px 40px",
          textAlign: "center",
          position: "relative",
          paddingBottom: "calc(40px + env(safe-area-inset-bottom))",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "radial-gradient(ellipse at 50% 100%, rgba(201,168,76,0.08) 0%, transparent 60%)",
            pointerEvents: "none",
          }}
        />
        <AnimatedSection>
          <div style={{ maxWidth: "400px", margin: "0 auto" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginBottom: "24px" }}>
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={12} fill="#C9A84C" color="#C9A84C" />
              ))}
            </div>
            <h2 style={{ fontSize: "clamp(22px, 5.5vw, 32px)", fontWeight: 700, lineHeight: 1.4, marginBottom: "16px" }}>
              지금, 당신의 운의 전략을<br />
              <span style={{ background: "linear-gradient(135deg, #C9A84C, #E8E0D5)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                릴리에게 물어보세요
              </span>
            </h2>
            <p style={{ fontSize: "13px", lineHeight: 1.75, color: "rgba(232,224,213,0.55)", marginBottom: "40px" }}>
              카카오톡에서 3분이면 충분합니다.<br />당신의 사주가 보내는 신호를 함께 읽어드립니다.
            </p>

            <button
              onClick={() => window.open(ctaUrl, "_blank")}
              style={{
                width: "100%",
                maxWidth: "360px",
                background: "linear-gradient(135deg, #C9A84C 0%, #A07830 100%)",
                border: "none",
                color: "#0D0D12",
                padding: "20px 32px",
                fontSize: "14px",
                fontWeight: 700,
                letterSpacing: "0.5px",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                boxShadow: "0 12px 50px rgba(201,168,76,0.4)",
                fontFamily: "inherit",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 16px 60px rgba(201,168,76,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 12px 50px rgba(201,168,76,0.4)";
              }}
            >
              지금 릴리에게 내 운의 전략 물어보기
              <ArrowRight size={16} />
            </button>

            <p style={{ fontSize: "11px", color: "rgba(232,224,213,0.3)", marginTop: "16px", letterSpacing: "1px" }}>
              카카오톡 채널 연결 · 무료 첫 상담
            </p>
          </div>
        </AnimatedSection>
      </section>

      {/* 개인정보처리방침 모달 */}
      {showPrivacy && (
        <div
          onClick={() => setShowPrivacy(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
            zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#1A1A22", border: "1px solid rgba(201,168,76,0.2)",
              borderRadius: "12px 12px 0 0", padding: "28px 24px 40px",
              width: "100%", maxWidth: "480px", maxHeight: "70vh", overflowY: "auto",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ fontSize: "16px", fontWeight: 700, color: "#C9A84C", margin: 0 }}>개인정보처리방침</h3>
              <button
                onClick={() => setShowPrivacy(false)}
                style={{ background: "none", border: "none", color: "rgba(232,224,213,0.5)", fontSize: "20px", cursor: "pointer" }}
              >✕</button>
            </div>
            <div style={{ fontSize: "12px", lineHeight: 1.9, color: "rgba(232,224,213,0.6)" }}>
              <p><strong style={{ color: "rgba(232,224,213,0.85)" }}>수집 항목:</strong> 생년월일, 태어난 시간(선택)</p>
              <p style={{ marginTop: "8px" }}><strong style={{ color: "rgba(232,224,213,0.85)" }}>수집 목적:</strong> AI 사주 분석 서비스 제공</p>
              <p style={{ marginTop: "8px" }}><strong style={{ color: "rgba(232,224,213,0.85)" }}>보유 기간:</strong> 서비스 이용 종료 시까지 (최대 1년)</p>
              <p style={{ marginTop: "8px" }}><strong style={{ color: "rgba(232,224,213,0.85)" }}>제3자 제공:</strong> 없음</p>
              <p style={{ marginTop: "12px", opacity: 0.7 }}>
                수집된 정보는 사주 분석 외 다른 목적으로 사용되지 않습니다. 귀하는 언제든지 개인정보 열람·삭제를 요청할 수 있습니다.
              </p>
              <p style={{ marginTop: "12px" }}><strong style={{ color: "rgba(232,224,213,0.85)" }}>문의:</strong> 리저너스 · 대표 현윤석<br />서울특별시 강서구 마곡중앙로 105-7, 3층 315호</p>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer
        style={{
          padding: "40px 24px 24px",
          borderTop: "1px solid rgba(201,168,76,0.1)",
          textAlign: "center",
          paddingBottom: "calc(24px + env(safe-area-inset-bottom))",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginBottom: "20px" }}>
          <div
            style={{
              width: "22px",
              height: "22px",
              borderRadius: "50%",
              border: "1px solid rgba(201,168,76,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Star size={10} fill="#C9A84C" color="#C9A84C" />
          </div>
          <span style={{ fontSize: "14px", letterSpacing: "4px", color: "#C9A84C", fontWeight: 600 }}>LILY</span>
        </div>

        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(201,168,76,0.06)",
            border: "1px solid rgba(201,168,76,0.15)",
            borderRadius: "100px",
            padding: "8px 18px",
            marginBottom: "24px",
          }}
        >
          <Zap size={12} color="#C9A84C" />
          <span style={{ fontSize: "11px", letterSpacing: "1px", color: "rgba(232,224,213,0.6)" }}>
            전문 명리학 데이터와 AI의 결합
          </span>
        </div>

        {/* 사업자 정보 */}
        <div
          style={{
            fontSize: "11px",
            color: "rgba(232,224,213,0.25)",
            lineHeight: 2,
            marginBottom: "16px",
            letterSpacing: "0.3px",
          }}
        >
          상호: 리저너스 &nbsp;|&nbsp; 대표자: 현윤석 &nbsp;|&nbsp; 사업자등록번호: 827-46-00854<br />
          통신판매업신고: 2023-서울중구-1802 &nbsp;|&nbsp; 주소: 서울특별시 강서구 마곡중앙로 105-7, 3층 315호
        </div>

        <p style={{ fontSize: "11px", color: "rgba(232,224,213,0.25)", letterSpacing: "0.5px", lineHeight: 1.8, marginBottom: "12px" }}>
          © 2026 Lily. Premium Saju Service.<br />
          ReasonUs All rights reserved.<br />
          <span style={{ fontSize: "10px", opacity: 0.6 }}>본 서비스는 오락·참고 목적이며 전문 상담을 대체하지 않습니다.</span>
        </p>

        {/* 개인정보처리방침 링크 */}
        <button
          onClick={() => setShowPrivacy(true)}
          style={{
            background: "none",
            border: "none",
            color: "rgba(201,168,76,0.45)",
            fontSize: "11px",
            cursor: "pointer",
            textDecoration: "underline",
            fontFamily: "inherit",
            letterSpacing: "0.5px",
          }}
        >
          개인정보처리방침
        </button>
      </footer>
    </div>
  );
}
